import React from "react";
import DateFnsUtils from "@date-io/date-fns";
import { startOfDay, endOfDay, startOfYear, endOfYear, startOfMinute, endOfMinute, parse } from "date-fns";
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import DateTimeRange from "./datetime";
import appConstant from "../../../../appConstants";

class DateTimeFilter extends React.Component{
    constructor(props){
        super(props);
        this.dateType = props.DATETYPE || appConstant.DATETYPES.DATE;
        this.isTimeInterval = Boolean(props.isTimeInterval);
        this.isFullRangeFilter = Boolean(props.isFullRangeFilter);
        this.state = {
            startDateTime : null,
            endDateTime: null
        }
    }

    getCurrentValue = (params) => {
        let currentValue = this.props.valueGetter(params.node);
        if(currentValue){
            currentValue =
               !this.props.useGetterValue && this.props.colDef.valueFormatter
                 ? this.props.colDef.valueFormatter({ value: currentValue, data: params.data  })
                 : currentValue;
        }
        return currentValue;
    }

    doesFilterPass(params) {
        const { startDateTime, endDateTime } = this.state;
        let currentValue = this.getCurrentValue(params)
        if (currentValue) {
            if (startDateTime && endDateTime) {
              // convert value single value to array so condition is run only once
              let timeWindows = Array.isArray(currentValue)
                ? currentValue
                : currentValue.split(",");
                if (this.isFullRangeFilter) {
                    // check current starttime and current endtime with filter 
                    // it should be "greater than or equal to" the filter starttime value, and "less than or equal to" the filter endtime value.

                    return (
                      timeWindows.findIndex((timeWindow) => {
                        let [currentStartTime, currentEndTime] = timeWindow
                          .split(this.dateType.intervalSeperator)
                          .map((time) =>
                            parse(time.trim(), this.dateType.format, new Date())
                          );
                        return (
                          currentStartTime >= startDateTime &&
                          currentEndTime <= endDateTime
                        );
                      }) > -1
                    );
                }
                if (this.isTimeInterval) {
                    timeWindows = timeWindows.map((timeWindow) =>
                      timeWindow.split(this.dateType.intervalSeperator)[0].trim()
                    );
                }

                return (
                  timeWindows.findIndex((curTimeWindow) => {
                    const timeWindow = parse(
                      curTimeWindow,
                      this.dateType.format,
                      new Date()
                    );
                        return (
                          timeWindow >= startDateTime &&
                          timeWindow <= endDateTime
                        );
                  }) > -1
                );
            }
            return false;
        }
        return this.props.passEmpty || false;
    }

    isFilterActive() {
        return Boolean(this.state.startDateTime) && Boolean(this.state.endDateTime);
    }
    
    // Set filter state
    setModel(model) {
        if (model === null) {
            this.setState({
                startDateTime: null,
                endDateTime: null
            });
        }
    }

    getModel() {
        return this.isFilterActive()
          ? [{ startDateTime: this.state.startDateTime, endDateTime: this.state.endDateTime }]
          : null;
    }

    onDateChange = (field, value) => {
        // reset seconds when filter column has time component, reset time to start and end of day when filter column doesnt have time component
        // this is will help while filter since we can directly compare date objects
        if(value){
            if([appConstant.DATETYPES.TIME.type, appConstant.DATETYPES.DATETIME.type].includes(this.dateType.type)){
                if(field === "startDateTime"){
                    value = startOfMinute(value);
                } else {
                    value = endOfMinute(value);
                }
            } else if(this.dateType.type === appConstant.DATETYPES.DATE.type){
                if(field === "startDateTime"){
                    value = startOfDay(value);
                } else {
                    value = endOfDay(value);
                }
            }
        } else {
            value = null;
        }

        this.setState({
            [field]:value
        }, this.props.filterChangedCallback);
    }

    render(){
        return(
         <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DateTimeRange
                dateType={this.dateType}
                startDateTime={this.state.startDateTime}
                endDateTime={this.state.endDateTime}
                startDateChanged={(date)=> this.onDateChange("startDateTime",date)}
                endDateChanged={(date)=> this.onDateChange("endDateTime",date)}
            />
         </MuiPickersUtilsProvider>
        )
    }
}

export default DateTimeFilter;